module.exports = __webpack_public_path__ + "media/images/front/knowledge_note/dba_logo-7fa3f96e651ca97cbefce58c4d0167b0.png";